import { IQuery, IQueryMediator } from 'core-ts-types';
import { IStandaloneNavigation, TStandaloneNavigationModel } from '../models/standalone_navigation_model';
import * as _4 from 'lodash4';

export class StandaloneSchedulerDetailsQuery implements IQuery {
  private _result: {
    userId: IStandaloneNavigation['userId'];
    apiCurrentTerm: IStandaloneNavigation['apiCurrentTerm'];
    isStandaloneSchedulerActive: boolean;
  };

  constructor(private QueryMediator: IQueryMediator, private ngStandaloneNavigationModel: TStandaloneNavigationModel) {
    QueryMediator.registerQuery(this, ngStandaloneNavigationModel);
  }

  run() {
    const standaloneNavDetails = this.ngStandaloneNavigationModel.read();
    this._result = {
      userId: standaloneNavDetails.userId,
      apiCurrentTerm: standaloneNavDetails.apiCurrentTerm,
      isStandaloneSchedulerActive: _4.isNumber(standaloneNavDetails.userId)
    };
    return this;
  }

  get result() {
    return this._result;
  }
}
angular.module('capability-ng-scheduler').service('ngStandaloneSchedulerDetailsQuery', StandaloneSchedulerDetailsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/standalone_scheduler/queries/standalone_scheduler_details_query.ts